<template>
  <base-side-page
    @cancel="cancelSidePage"
    :title="$t('bill.dimension')"
    icon="dimension"
    :res-name="detailData.name"
    :current-tab="params.windowData.currentTab"
    :loaded="loaded"
    :tabs="detailTabs"
    @tab-change="handleTabChange">
    <template v-slot:actions>
      <actions
        :options="singleActions"
        :row="detailData"
        :before-show-menu="beforeShowMenu"
        button-type="link"
        button-size="small" />
    </template>
    <component :is="params.windowData.currentTab" :domainList="domainList || []" :projectList="projectList || []" :res-id="data.id" :id="listId" :data="detailData" :on-manager="onManager" :getParams="getParams" @tab-change="handleTabChange" />
  </base-side-page>
</template>

<script>
import DimensionItemList from '@Bill/views/dimension/components/DimensionItemList'
import Actions from '@/components/PageList/Actions'
import SidePageMixin from '@/mixins/sidePage'
import WindowsMixin from '@/mixins/windows'
import ColumnsMixin from '../mixins/columns'
import SingleActionsMixin from '../mixins/singleActions'
import DimensionMixin from '../mixins/dimension'
import detail from './Detail'

export default {
  name: 'DimensionSidePage',
  components: {
    Actions,
    detail,
    DimensionItemList,
  },
  mixins: [SidePageMixin, WindowsMixin, ColumnsMixin, SingleActionsMixin, DimensionMixin],
  data () {
    return {
      detailTabs: [
        { label: this.$t('bill.text_185'), key: 'detail' },
        { label: this.$t('bill.text_289'), key: 'dimension-item-list' },
        { label: this.$t('cloudenv.text_15'), key: 'event-drawer' },
      ],
      domainList: this.params.domainList,
      projectList: this.params.projectList,
    }
  },
  computed: {
    getParams () {
      return {
        proxy_setting: this.detailData.id,
      }
    },
    listId () {
      switch (this.params.windowData.currentTab) {
        case 'event-drawer':
          return 'EventListForProjectMappingSidePage'
        case 'dimension-item-list':
          return 'DimensionItemListForDimensionSidePage'
        default:
          return ''
      }
    },
  },
  created () {
    this.$bus.$on('dimensionDomainUpdated', (val) => {
      this.domainList = val
    })
    this.$bus.$on('dimensionProjectUpdated', (val) => {
      this.projectList = val
    })
  },
  methods: {
    openSidePageDimensionItemList () {
      this.handleTabChange('dimension-item-list')
    },
  },
}
</script>
